/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Stamps_TextInputs */

const en_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stamps x ${i?.number}`)
};

const ar_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`طوابع x ${i?.number}`)
};

const de_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stempel x ${i?.number}`)
};

const es_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sellos x ${i?.number}`)
};

const fr_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timbres x ${i?.number}`)
};

const it_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timbri x ${i?.number}`)
};

const ja_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スタンプ x ${i?.number}`)
};

const ko_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`스탬프 x ${i?.number}`)
};

const pt_br_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selos x ${i?.number}`)
};

const ru_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Штампы x ${i?.number}`)
};

const th_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แสตมป์ x ${i?.number}`)
};

const tr_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pul x ${i?.number}`)
};

const zh_cn_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`印花 x ${i?.number}`)
};

const zh_tw_stamps_text = /** @type {(inputs: Stamps_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`印花 x ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Stamps x {number}" |
*
* @param {Stamps_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const stamps_text = /** @type {((inputs: Stamps_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stamps_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stamps_text(inputs)
	if (locale === "ar") return ar_stamps_text(inputs)
	if (locale === "de") return de_stamps_text(inputs)
	if (locale === "es") return es_stamps_text(inputs)
	if (locale === "fr") return fr_stamps_text(inputs)
	if (locale === "it") return it_stamps_text(inputs)
	if (locale === "ja") return ja_stamps_text(inputs)
	if (locale === "ko") return ko_stamps_text(inputs)
	if (locale === "pt_br") return pt_br_stamps_text(inputs)
	if (locale === "ru") return ru_stamps_text(inputs)
	if (locale === "th") return th_stamps_text(inputs)
	if (locale === "tr") return tr_stamps_text(inputs)
	if (locale === "zh_cn") return zh_cn_stamps_text(inputs)
	return zh_tw_stamps_text(inputs)
});